import React from 'react';

interface LayoutAppProps {
    className?: string
    className2?: string
    children: React.ReactNode
}

const LayoutApp = ({className, className2, children}: LayoutAppProps) => {
    return (
        <div className={`mx-auto max-w-screen-2xl lg:p-8 md:p-4 p-2 ${className}`}>
            <div className={`relative overflow-hidden ${className2 ?? 'bg-white border-[rgba(0,0,0,0.1)] border-[1px] shadow-dashboard-setup-intro-form rounded-lg'} flex flex-col gap-y-6`}>
                {children}
            </div>
        </div>
    );
};

export default LayoutApp;